import type { FaireProductEntity } from "../../entity_types/product";

export const p_62hhnddb46: FaireProductEntity = {
  token: "p_62hhnddb46",
  type: "product",
  name: "Corner Hoops",
  brandToken: "b_5fhorwgw5m",
  brandName: "Peter and June",
  imageUrl:
    "https://cdn.faire.com/fastly/904f75fc5c589987adaa5c0fb4da2bd926498f77668f22b42618caee77237efb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a365a961045e800f1572327aa62859cd7f63727ad90184bac412c8a8e615430a.jpeg",
  ],
  priceDollars: 14,
  description:
    "* 18k gold plated over stainless steel\n* or stainless steel\n* water proof\n* about .5mm thick and dangles about 2.5mm\n* nickel/lead free\n* made with materials ethically sourced",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:43.190Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
